"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _ModalHeader = _interopRequireDefault(require("./ModalHeader"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ModalContent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ModalContent, _React$Component);

  function ModalContent() {
    _classCallCheck(this, ModalContent);

    return _possibleConstructorReturn(this, _getPrototypeOf(ModalContent).apply(this, arguments));
  }

  _createClass(ModalContent, [{
    key: "getAnimation",

    /**
     * Gets a different animation depending on visible value.
     * @param {boolean} visible - visibility state of modal
     * @returns {string} name of animation
     */
    value: function getAnimation(visible) {
      var animation;

      if (!(0, _isUndefined2.default)(visible) && visible === true) {
        animation = 'pop-in';
      } else if (!(0, _isUndefined2.default)(visible) && visible === false) {
        animation = 'pop-out';
      } else {
        animation = '';
      }

      return animation;
    }
    /**
     * Footer for modal
     * @param {node} footer - footer node
     * @param {node} primaryButtonLabel - Label for primary button
     * @param {function} primaryButtonOnClick - primary button callback
     * @param {object} primaryButtonProps - Props to pass to primary button
     * @returns {node} of footer node
     */

  }, {
    key: "renderFooter",
    value: function renderFooter(footer, primaryButtonLabel, primaryButtonOnClick, primaryButtonProps) {
      if (footer === true) {
        return _react.default.createElement(_Button.default, _extends({
          onClick: primaryButtonOnClick
        }, primaryButtonProps), primaryButtonLabel);
      } else if ((0, _isArray2.default)(footer)) {
        return _react.default.createElement(_FlexLayout.default, {
          itemSpacing: "10px",
          justifyContent: "flex-end"
        }, footer);
      }

      return footer;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          footer = _this$props.footer,
          headerActions = _this$props.headerActions,
          onClose = _this$props.onClose,
          closeIconProps = _this$props.closeIconProps,
          primaryButtonLabel = _this$props.primaryButtonLabel,
          primaryButtonOnClick = _this$props.primaryButtonOnClick,
          primaryButtonProps = _this$props.primaryButtonProps,
          title = _this$props.title,
          visible = _this$props.visible,
          width = _this$props.width;

      var clsPrfx = _ThemeManager.default.getVar('classPrefix');

      return _react.default.createElement("div", {
        className: "".concat(clsPrfx, "-modal-content ").concat(clsPrfx),
        "data-animation": this.getAnimation(visible),
        style: {
          width: width
        }
      }, _react.default.createElement(_ModalHeader.default, {
        headerActions: headerActions,
        onClose: onClose,
        closeIconProps: closeIconProps,
        size: "default"
      }, title), _react.default.createElement("div", {
        className: "modal-body"
      }, children), _react.default.createElement("div", {
        className: "modal-footer"
      }, this.renderFooter(footer, primaryButtonLabel, primaryButtonOnClick, primaryButtonProps)));
    }
  }]);

  return ModalContent;
}(_react.default.Component);

exports.default = ModalContent;
ModalContent.propTypes = {
  /**
   * Content to be displayed in modal body.
   */
  children: _propTypes.default.node,

  /**
   * Footer for modal. Can be a node or default as true. When set to a value other than true, the
   * props primaryButtonLabel and primaryButtonOnClick will no longer be usable.
   */
  footer: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.node]),

  /**
   * Place primary modal actions here. For example Close and Help icons. Note: Usage of this
   * property will negate the built in onClose prop.
   */
  headerActions: _propTypes.default.node,

  /**
   * The onClose callback will be called when the close (X) action is clicked.
   */
  onClose: _propTypes.default.func,

  /**
   * Label for primary modal button.
   */
  primaryButtonLabel: _propTypes.default.node,

  /**
   * The callback handler called when the primary button is clicked.
   */
  primaryButtonOnClick: _propTypes.default.func,

  /**
   * Props to pass to primary button
   */
  primaryButtonProps: _propTypes.default.object,

  /**
   *  Title of the modal.
   */
  title: _propTypes.default.string,

  /**
   * Visible will to determine whether the modal dialog is visible or not.
   */
  visible: _propTypes.default.bool,

  /**
   * Width of modal. (in px)
   */
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};